import { useMutation, useQueryClient } from "react-query";
import axios from 'axios';

const editCertificated = async (payload) => {
  const { data } = await axios.put(
    process.env.REACT_APP_API + "/api/v1/billing/business/certificated/"+payload.id,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    },
  );
  return data;
};

export const useEditCertificated = () =>{
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: editCertificated,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["get-company"] });
      },
    });
}

